import { render } from "./PaymentPage.vue?vue&type=template&id=47ad90bb"
import script from "./PaymentPage.vue?vue&type=script&lang=js"
export * from "./PaymentPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__